import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const footerLinks = [
    {
      name: "Terms of Service",
      link: "/terms-of-service",
    },
    {
      name: "Privacy Policy",
      link: "/privacy-policy",
    },
    {
      name: "Cookie Policy",
      link: "/cookie-policy",
    },
    {
      name: "contact",
      link: "/contact-us",
    },
  ];

  return (
    <footer className="bg-black text-white w-full py-12 px-8">
      <div className="flex justify-between items-center max-w-screen-xl mx-auto">
        <div className="">
          &copy; {new Date().getFullYear()} Stride by Dazetta. All Rights
          Reserved.
        </div>
        <div className="">
          <div className="flex items-center gap-5">
            {footerLinks.map((footer) => (
              <div className=" flex word" key={footer.name}>
                <Link
                  to={footer.link}
                  className="font-medium text-primary-600 break-keep hover:underline"
                >
                  {footer.name}
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
